import SectionMixin from '@/mixins/sectionMixin'

//formulajs calc
import {IRR, NOMINAL} from '@formulajs/formulajs'

export default {
    name: 'vtu-simulator-account',
    mixins: [SectionMixin],
    props:{
        type: String,
        title: String,
        subtitle: String,
        infoField: String,
        warningField: String,
        tooltip: {},
        info: {},
        questions: {},
    },
    
    data: ()=>{
        return {
            amount: 0,
            total: Number,

            eaRateAccount: Number,
            eaRateAccountPro: Number,
            eaRateAccountTime60: Number,
            eaRateAccountTime60Pro: Number,
            eaRateAccountTime90: Number,
            eaRateAccountTime90Pro: Number,

            months: Number,

            showError: false,
            showErrorSelectedAccount: false,
            vtuClosed: true,
            selectMonth: "",
            selectAccountType:"",
            selectedAccountRate: null,
            AccountType: [{ text: 'Bolsillo Programado', value: 1 },{ text: 'Bolsillo Flex', value: 2 }],
            AccountOptions: [],
        }
    },
    beforeMount(){
        this.wording = this.$store.state.wording.data.attributes
        
        if(this.$store.state.page["vtu-account"]){
            this.variablesAccount = this.$store.state.page["vtu-account"].data.attributes.simulator
            this.eaRateAccount = this.variablesAccount.ea_rate
            this.eaRateAccountPro = this.variablesAccount.ea_rate_pro

            this.uvtAccount = this.variablesAccount.uvt_value
            this.factorAccount = this.variablesAccount.factor_value
            this.rteAccount = this.variablesAccount.rte_value

            this.eaRateAccountTime60 = this.variablesAccount.ea_rate_time_60
            this.eaRateAccountTime60Pro = this.variablesAccount.ea_rate_time_60_pro
            this.eaRateAccountTime90 = this.variablesAccount.ea_rate_time_90
            this.eaRateAccountTime90Pro = this.variablesAccount.ea_rate_time_90_pro
        }
    },
    mounted() {

        this.$el.addEventListener("submit", (evt)=>{
            evt.preventDefault()
            this.checkForm()
        })

        this.$refs["vtu-amount"].addEventListener("change", ()=>{

            this.inputValue = this.$refs["vtu-amount"].value
            let inputValueNumber = Number(this.inputValue).toLocaleString("en-US")
            let sourceLabel = document.querySelector('.form-group-label')
            if(this.inputValue){
                sourceLabel.innerHTML = inputValueNumber
            }else{
                sourceLabel.innerHTML = ''
            }

        })
    },

    methods: {
        saveUrlToScroll(url,id) {
            localStorage.setItem('scrollToElementId',id);
            this.$router.push(url);
        },
        generateOptions: function (start, max, jumps) {
            let options = [];
            for (let i = start; i <= max; i += jumps) {
                options.push({
                    text: `${i} ${i === 1 ? 'Mes' : 'Meses'}`,
                    value: i
                })
            }
            return options;
        },
        onChange(id){
            if (id === "radio-group") {
                this.showErrorSelectedAccount = !this.selectedAccountRate;
            }
        },
        checkForm: function () {
            this.inputValue = this.$refs["vtu-amount"].value

            if(this.inputValue && this.selectMonth && this.selectedAccountRate){
                this.amount = Number(this.inputValue)
                this.months = this.selectMonth
                this.showError = false
                this.showErrorSelectedAccount = false
                this.vtuClosed = false
            }
            if(!this.selectedAccountRate){
                this.showErrorSelectedAccount = true
            }
            
        },
/*------------------------Account----------------------------*/
        calculateEA: function(eaRate){
            const toNominal = eaRate/100;
            return toNominal;
        },

        calculateMV: function(EA, months = 12){
            return (NOMINAL(EA, months))*100;
        },

        calculateTable: function({amount, months, MV}){
            
            const monthsAverage = 30.4166666;
            const dailyTIR = ((MV/365)/100);
            const baseRte = (this.uvtAccount*this.factorAccount);
            const rtePercentage = (this.rteAccount/100)

            let previousAmount = amount;

            const data = Array(months).fill().map((_, index) =>{
                const dailyInterest = previousAmount * dailyTIR;
                const monthlyInterest = dailyInterest * monthsAverage;
      
                previousAmount += monthlyInterest;

                let rte = 0;
                if(dailyInterest >= baseRte){
                    rte = (dailyInterest*rtePercentage*monthsAverage)
                }else{
                    rte = 0
                }

                return {
                    amount: index === 0 ? amount : previousAmount,
                    dailyInterest: dailyInterest,
                    interests: monthlyInterest,
                    rte: rte,
                }
            });
            return data;
        },

        calculateMonthlyTIR: function(totalAmount){
            return IRR(totalAmount);
        },

        calculateTimePokets: function(eaRate) {

            const eaRateDecimal = this.calculateEA(eaRate);
            
            const days = this.selectMonth * 30;
            const interestRate = Math.pow(1 + eaRateDecimal, days / 365) - 1;
            const interestEarned = this.amount * interestRate;

            const dailyInterest = interestEarned / days;

            const baseRte = this.uvtAccount * this.factorAccount;
            const rtePercentage = this.rteAccount / 100;
            let rte = 0;
            if (dailyInterest >= baseRte) {
                rte = dailyInterest * rtePercentage * days;
            }

            return {
                Interest: interestEarned,
                Rte: rte,
                Total: this.amount + interestEarned - rte
            };
        },

        getAccountCalculations(eaRate){
            const EA = this.calculateEA(eaRate)
            const MV = this.calculateMV(EA)
            const data = this.calculateTable({ amount: this.amount , months: this.months, MV})
            const FirstMonthData = data.length > 0 ? data[0] : null;
            const FirstDailyInterest = FirstMonthData ? FirstMonthData.dailyInterest : null;
            const Interest = data.reduce((acc, {interests}) => acc + interests, 0)
            const Rte = data.reduce((acc, {rte}) => acc + rte, 0)
            const Total = this.amount + Interest - Rte
            const MonthlyTIR = Number(this.calculateMonthlyTIR([-this.amount, ...data.reduce((acc, {amount}) => [...acc, amount], [])], Total)).toFixed(3)

            return {EA, FirstDailyInterest, Interest, Rte, MonthlyTIR, Total}
        }

    },

    computed:{
        accountRateOptions() {
            if (this.selectAccountType === 1) {
                if(this.selectMonth === 2){
                    return [
                        { value: this.eaRateAccountTime60, label: `${this.eaRateAccountTime60}% E.A.`, description: 'Solo por ser Lulo' },
                        { value: this.eaRateAccountTime60Pro, label: `${this.eaRateAccountTime60Pro}% E.A.`, description: 'Si eres Lulo Pro' }
                    ];
                }else{
                    return [
                        { value: this.eaRateAccountTime90, label: `${this.eaRateAccountTime90}% E.A.`, description: 'Solo por ser Lulo' },
                        { value: this.eaRateAccountTime90Pro, label: `${this.eaRateAccountTime90Pro}% E.A.`, description: 'Si eres Lulo Pro' }
                    ];
                }
            } else if (this.selectAccountType === 2) {
            return [
                { value: this.eaRateAccount, label: `${this.eaRateAccount}% E.A.`, description: 'Solo por ser Lulo' },
                { value: this.eaRateAccountPro, label: `${this.eaRateAccountPro}% E.A.`, description: 'Si eres Lulo Pro' }
            ];
            }
            return [];
        },
        filteredQuestions() {
            if(this.selectAccountType === 1){
                return this.questions.filter(q => Number(q.pocket_time) === 1);
            }else{
                return this.questions.filter(q => Number(q.pocket_time) === 0);
            }
        },
        selectedAccount(){
            if(this.selectAccountType === 1){
                return this.calculateTimePokets(this.selectedAccountRate)
            }else{
                return this.getAccountCalculations(this.selectedAccountRate)
            }            
        },
        accountStandard(){
            return this.getAccountCalculations(this.eaRateAccount)
        },
        accountPro(){
            return this.getAccountCalculations(this.eaRateAccountPro)
        },
        accountTime60(){
            return this.calculateTimePokets(this.eaRateAccountTime60)
        },
        accountTime60Pro(){
            return this.calculateTimePokets(this.eaRateAccountTime60Pro)
        },
        accountTime90(){
            return this.calculateTimePokets(this.eaRateAccountTime90)
        },
        accountTime90Pro(){
            return this.calculateTimePokets(this.eaRateAccountTime90Pro)
        },
    },

    watch:{
        selectAccountType(value){
            if(value === 1){
                this.AccountOptions = [{ text: '2 meses (60 días)', value: 2},{ text: '3 meses (90 días)', value: 3}]
                this.selectedAccountRate = ''
                this.vtuClosed = true
            }else if(value === 2){
                this.AccountOptions = this.generateOptions(1,12,1)
                this.selectedAccountRate = ''
                this.vtuClosed = true
            }
            this.selectMonth = ""
        },
        selectMonth() {
            this.selectedAccountRate = ''
            this.vtuClosed = true
        }
    }
}